const urls = {

    base: "https://school-diary-app.netlify.app",

    subscribe: "https://schooldiary.asvirtual.repl.co/api/subscribe",

    unsubscribe: "https://schooldiary.asvirtual.repl.co/api/unsubscribe",
    
    getSchool: "https://schooldiaryapi.netlify.app/.netlify/functions/api/getSchool",
    // getSchool: "https://schooldiary.asvirtual.repl.co/api/getSchool",

    getSubjects: "https://schooldiaryapi.netlify.app/.netlify/functions/api/getSubjects",

    emailVerificationRedirect: "https://school-diary-app.netlify.app/emailVerification",

    login: "https://school-diary-app.netlify.app/login",

    signup: "https://schooldiary.asvirtual.repl.co/api/signup",

    notifyEventAdded: "https://schooldiary.asvirtual.repl.co/api/notifyEventAdded",

    notifyAnnouncementAdded: "https://schooldiary.asvirtual.repl.co/api/notifyAnnouncementAdded",

    createCheckoutSession: "https://schooldiaryapi.netlify.app/.netlify/functions/api/createCheckoutSession",
    // createCheckoutSession: "https://schooldiary.asvirtual.repl.co/api/createCheckoutSession",

    createPortalSession: "https://schooldiaryapi.netlify.app/.netlify/functions/api/createPortalSession",
    // createPortalSession: "https://schooldiary.asvirtual.repl.co/api/createPortalSession",

    cancelPremiumSubscription: "https://schooldiaryapi.netlify.app/.netlify/functions/api/cancelPremiumSubscription",
    // cancelPremiumSubscription: "https://schooldiary.asvirtual.repl.co/api/cancelPremiumSubscription",

    googleAuthToken: "https://schooldiaryapi.netlify.app/.netlify/functions/api/oauth2callback",
    // googleAuthToken: "https://schooldiary.asvirtual.repl.co/api/oauth2callback",

    googleAuthTokenRevoke: "https://schooldiaryapi.netlify.app/.netlify/functions/api/oauth2revoke",
    // googleAuthTokenRevoke: "https://schooldiary.asvirtual.repl.co/api/oauth2revoke",

    discord: "https://schooldiaryapi.netlify.app/.netlify/functions/api/discord",
    // discord: "https://schooldiary.asvirtual.repl.co/api/discord",

    revokeDiscord: "https://schooldiaryapi.netlify.app/.netlify/functions/api/revokeDiscord",
    // revokeDiscord: "https://schooldiary.asvirtual.repl.co/api/revokeDiscord",

    getDiscordUserData: "https://schooldiary-discord-bot.asvirtual.repl.co/api/discord",

    fallbackEmailVerification: "https://schooldiary.asvirtual.repl.co/api/verifyEmail",

    bugReport: "https://schooldiary.asvirtual.repl.co/api/report",

    betaTester: "https://schooldiary.asvirtual.repl.co/api/betaTester",

};

/*const urls = {

    base: "http://localhost:3000",

    subscribe: "https://testrepl.asvirtual.repl.co/api/subscribe",

    unsubscribe: "https://testrepl.asvirtual.repl.co/api/unsubscribe",

    getSchool: "https://schooldiary.asvirtual.repl.co/api/getSchool",

    getSubjects: "https://schooldiaryapi.netlify.app/.netlify/functions/api/getSubjects",
    
    emailVerificationRedirect: "http://localhost:3000/emailVerification",

    login: "http://localhost:3000/login",

    notifyEventAdded: "https://testrepl.asvirtual.repl.co/api/notifyEventAdded",

    createCheckoutSession: "https://testrepl.asvirtual.repl.co/api/createCheckoutSession",

    createPortalSession: "https://testrepl.asvirtual.repl.co/api/createPortalSession",

    cancelPremiumSubscription: "https://testrepl.asvirtual.repl.co/api/cancelPremiumSubscription",

    googleAuthToken: "https://testrepl.asvirtual.repl.co/api/oauth2callback",

    discord: "https://testrepl.asvirtual.repl.co/api/discord",

    revokeDiscord: "https://testrepl.asvirtual.repl.co/api/revokeDiscord",

    getDiscordUserData: "https://schooldiary-discord-bot.asvirtual.repl.co/api/discord",

};*/

export default urls;